// Lettoria config for the BS26 "Build your sale list" quiz. Plain, few words (anh 11-01).
// Customer voice (research/insights-261101-0045-…): 50–76, ~30 gift buys vs ~11 self → "Gifts" first; men buy for
// wife/girlfriend; "always carry a book", Kindle/laptop never mentioned → no laptop answer; Poe #1; matching wallet #1 add-on.
// Quiz style + browse filter = the store's own collection styles (style:<id> tags). Avoid "faux leather", "cutesy".
// Store values (brand, dates, SMS, share text, calendar start) come from the section via window.SLQ_PAGE.
window.SLQ_CONFIG = Object.assign({
  tiers: [0, 0.65, 0.70, 0.75, 0.80],
  topPicks: false, // "Popular in the sale" row — OFF (anh 11-02: confusing above the quiz)
  // Photo strip order (11-02, before Lettoria's first send: no page data yet -> ops best-seller rank; Poe's Library = #1 and top b26-top10 pick).
  marqueeDesigns: ["Poe's Library Ashen Black", "The Codex of Gothic Tales Deadlight Black", "Dracula's Guest", "Down The Rabbit Hole", "The Raven", "The Dracula", "Frankenstein Lablight Violet", "The Crimson Codex", "Lovecraftian Black", "The Codex of Gothic Tales Violet Echo"],
  collections: [{ id: 'poes-library', label: 'Poe’s Library' }, { id: 'monsters-madmen', label: 'Monsters & Madmen' },
    { id: 'lovecraft-the-weird', label: 'Lovecraft & the Weird' }, { id: 'shakespeare', label: 'Shakespeare' },
    { id: 'childhood-classics', label: 'Childhood Classics' }, { id: 'the-bookshelf', label: 'The Bookshelf' }],

  who: {
    q: 'Who are you shopping for?',
    options: [{ id: 'gifts', label: 'Gifts' }, { id: 'both', label: 'Me + gifts' }, { id: 'me', label: 'Just me' }],
  },

  recipients: {
    q: 'Who’s on your list?',
    sub: 'Tap all that apply.',
    options: [
      { id: 'daughter', for: 'your daughter', label: 'Daughter', her: 'her', types: ['crossbody', 'small handbag', 'tote'], looks: ['childhood-classics', 'poes-library'] },
      { id: 'wife', for: 'your wife', label: 'Wife / girlfriend', her: 'her', types: ['handbag', 'small handbag', 'tote'], looks: ['poes-library', 'monsters-madmen'] },
      { id: 'friend', for: 'a friend', label: 'Friend', her: 'her', types: ['wallet', 'mini wallet', 'makeup bag'], looks: ['poes-library', 'childhood-classics'] },
      { id: 'sister', for: 'your sister', label: 'Sister', her: 'your sister', types: ['crossbody', 'small handbag', 'wallet'], looks: ['monsters-madmen', 'poes-library'] },
      { id: 'reader', for: 'a book lover', label: 'Book lover', her: 'her', types: ['tote', 'wallet', 'handbag'], looks: ['the-bookshelf', 'poes-library'] },
      { id: 'mama', for: 'Mom', label: 'Mom', her: 'Mom', types: ['small handbag', 'wallet'], looks: ['childhood-classics', 'the-bookshelf'] },
      { id: 'coworker', for: 'a coworker', label: 'Coworker', her: 'her', types: ['mini wallet', 'wallet', 'makeup bag'], looks: ['the-bookshelf', 'childhood-classics'] },
      { id: 'hardest', for: 'someone hard to shop for', label: 'Someone hard to shop for', her: 'her', types: ['wallet', 'small handbag', 'crossbody'], looks: ['top'] },
    ],
  },

  moment: {
    q: 'Where will you use your bag most?',
    options: [
      { id: 'book', label: 'Carry a book + everything', types: ['tote', 'handbag'], why: 'Room for a book and more', whyTypes: ['tote', 'handbag'], whyAlt: 'Room for the everyday things' },
      { id: 'everyday', label: 'Small & everyday', types: ['small handbag', 'crossbody'], why: 'Small and easy every day' },
      { id: 'trip', label: 'Trips & book events', types: ['tote', 'crossbody'], why: 'Easy to carry all day' },
      { id: 'out', label: 'Going out', types: ['crossbody', 'small handbag'], why: 'Small for evenings out' },
    ],
  },

  giftKind: {
    q: 'What kind of gifts?',
    options: [
      { id: 'bags', label: 'Bags', sub: 'from $17.99', types: ['small handbag', 'crossbody', 'handbag', 'tote'] },
      { id: 'little', label: 'Small gifts', sub: 'from $7.99', types: ['mini wallet', 'wallet', 'makeup bag', 'charm'] },
      { id: 'mix', label: 'A mix', types: null },
    ],
  },

  designIntro: {
    'The Dracula': 'Dracula book cover and portrait in a silver frame.',
    'The Crimson Codex': 'A shelf of classic horror books with a clock and roses, in deep red.',
    'Frankenstein Lablight Violet': 'Frankenstein in pop-art purple and neon green.',
    'The Codex of Gothic Tales Deadlight Black': 'A gothic bookshelf with a skull, in black.',
    'Lovecraftian Black': 'A Lovecraft bookshelf with a skull, in black.',
    'The Raven': 'Poe’s portrait with a raven, in black and white.',
    'Dracula’s Guest': 'Dracula’s castle in red and black.',
    'Dracula\'s Guest': 'Dracula’s castle in red and black.',
    'The Codex of Gothic Tales Violet Echo': 'Bats and a skull on purple.',
    'Frankenstein Ashes of Hope': 'Black-and-white stills in classic film style.',
    'Poe\'s Library Ashen Black': 'A shelf of Edgar Allan Poe’s works, in black.',
    'Down The Rabbit Hole': 'Classic engravings from the 1865 Alice book, in navy.',
    'Hundred Acre Dream': 'Character badges in the original 1920s book style, in green.',
    'The Black Cat': 'Poe’s “The Black Cat” with yellow cat eyes, in black.',
    'The Phantom Of The Opera': 'A Phantom mask with roses, in navy.',
  },

  look: {
    qMe: 'Which stories do you love?',
    qHer: 'Which stories fit your list?',
    options: [
      { id: 'poes-library', label: 'Poe’s Library', designs: ['Poe\'s Library Ashen Black', 'The Raven', 'The Black Cat'], why: 'Poe design' },
      { id: 'monsters-madmen', label: 'Monsters & Madmen', designs: ['Dracula\'s Guest', 'The Dracula', 'Frankenstein Lablight Violet', 'The Phantom Of The Opera', 'Frankenstein Ashes of Hope'], why: 'Classic monster design' },
      { id: 'childhood-classics', label: 'Childhood Classics', designs: ['Hundred Acre Dream', 'Down The Rabbit Hole'], why: 'Childhood classic design' },
      { id: 'the-bookshelf', label: 'The Bookshelf', designs: ['The Codex of Gothic Tales Deadlight Black', 'The Crimson Codex', 'The Codex of Gothic Tales Violet Echo'], why: 'Bookshelf design' },
      { id: 'lovecraft-the-weird', label: 'Lovecraft & the Weird', designs: ['Lovecraftian Black'], why: 'Lovecraft design' },
    ],
    giftOnlyExtra: { id: 'top', label: 'Not sure? Our #1 best seller', designs: ['Poe\'s Library Ashen Black'], why: 'Our #1 best seller' },
  },
}, window.SLQ_PAGE || {});
